import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import DatePickerField from 'Components/Atoms/Fields/DatePickerField/DatePickerField';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Grid from 'Components/Atoms/Grid/Grid';
import { connect } from 'react-redux';
import CssHelper from 'Services/Utils/Css/CssHelper';
import { StoreState } from 'Store/Reducers';
import styles from './FilterTabDateRange.module.sass';
import {useEffect} from 'react';

const FilterTabDateRange = ({
                                                   values,
                                                   title, isOpen,
                                                   onTabClick, onFilterClick,
                                               }: FilterTabDateRangeProps) => {
    const handleTabClick = () => onTabClick();

    const handleFilterClick = (value) => {
        if (value?.length === 0) {
            onFilterClick([]);

            return;
        };
        const startDate = value?.[0]?.format('YYYY-MM-DD');
        const endDate = value?.[1]?.format('YYYY-MM-DD');

        onFilterClick(`${startDate},${endDate}`);
    };

    const cssClass = CssHelper.createCssClass(`
        ${styles['filtertab__content-item']}
        ${styles['filtertab__content-item__state--'+(isOpen?'open':'closed')]}
        ${styles['filtertab__content-item__filters--'+(values.length > 0?'active':'inactive')]}
    `);

    return <div className={cssClass}>
        <div
            className={styles['filtertab__content-item-header']}
            onClick={handleTabClick}
        >
            { title } { values.length > 0 && <>
            ({ values.length > 0 ? 1 : 0 }/1)
        </> }
            <div
                className={styles['filtertab__content-item-header-icons']}
            >
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={styles['filtertab__content-item-header-arrow']}
                />
            </div>
        </div>

        {
            isOpen &&
            <Grid>
                <div className={styles['filtertab__content-item-list']}>
                    <DatePickerField
                        value={values}
                        onChange={handleFilterClick}
                    />
                </div>
            </Grid>
        }
    </div>;
}

interface Props {
    values: any[]
    title: string
    isOpen: boolean
    onTabClick?: any
    onFilterClick: any
}

const mapState = (state: StoreState, props: Props) => ({

});

const mapDispatch = {

};

type FilterTabDateRangeProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(FilterTabDateRange);